import { getLocalizationInfo } from '@/project.config';
import { useParams } from 'next/navigation';

const useI18n = () => {
  const { locale } = useParams();

  const config = getLocalizationInfo(locale);

  const country = config.countryCode;

  const currency = config.currency;


  return { country, currency };
};

export default useI18n;
